export enum HolidayLimitBriefDisplayMode {
  NORMAL = 0,
  ONLY_OCCASIONAL_HOME_OFFICE = 1,
}
